module.exports = __webpack_public_path__ + "media/packs/src/assets/images/empty-lesson-70bc4b7eea3a147cc9c2757b2c75e76f.png";